export default __webpack_public_path__ + "static/media/book-scouts.06f67635.jpg";